/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { InjectionToken } from '@angular/core';

export class TimeRecordingInjectionToken {
  static readonly BASE_URL = new InjectionToken<string>('base url');
  static readonly VERSION = new InjectionToken<string>('version');
}
